<template>
  <transition
    class="zoox-component zoox-page-transition"
    :name="type"
    mode="out-in"
  >
    <slot></slot>
  </transition>
</template>

<script>
/**
 * @displayName Page Transition
 */
export default {
  name: 'ZPageTransition',
  props: {
    /**
     * Flag para indicar o estilo da trasição, atualmente temos como opções `fade`, `fade-in-up`, `fade-in-right`, `fade-in-down`, `fade-in-left`.
     */
    type: {
      type: String,
      default: 'fade-in-right',
    },
  },
}
</script>

<style lang="scss" scoped>
@import './styles/fade';
@import './styles/fade-in-down';
@import './styles/fade-in-up';
@import './styles/fade-in-left';
@import './styles/fade-in-right';
</style>
